import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { translations } from '../translations';

export const KVKK = () => {
  const { language } = useLanguage();
  const t = translations[language];

  return (
    <div className="min-h-screen pt-32 pb-20 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-4xl font-bold text-gray-900 mb-8">{t.kvkk.title}</h1>
        <div className="bg-white rounded-xl shadow-lg p-8">
          <div className="prose prose-lg max-w-none">
            <p className="text-gray-600 mb-6">{t.kvkk.content}</p>
            
            <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">
              {language === 'tr' ? 'Veri Sorumlulu' : 'Data Controller'}
            </h2>
            <p className="text-gray-600 mb-4">
              {language === 'tr'
                ? 'NanoGen, 6698 sayılı Kişisel Verilerin Korunması Kanunu (“KVKK”) uyarınca veri sorumlusu sıfatıyla, kişisel verilerinizi aşağıda açıklanan kapsam ve amaçlar dahilinde işlemektedir.'
                : 'NanoGen, as the data controller under the Personal Data Protection Law No. 6698 ("KVKK"), processes your personal data within the scope and purposes described below.'}
            </p>

            <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">
              {language === 'tr' ? 'İşlenen Kişisel Veriler' : 'Personal Data Processed'}
            </h2>
            <p className="text-gray-600 mb-4">
              {language === 'tr'
                ? 'Kimlik bilgileriniz (ad, soyad), iletişim bilgileriniz (telefon, e-posta, adres), ve işlem güvenliği bilgileriniz (IP adresi, çerez kayıtları) işlenmektedir.'
                : 'Your identity information (name, surname), contact information (phone, email, address), and transaction security information (IP address, cookie records) are processed.'}
            </p>

            <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">
              {language === 'tr' ? 'Kişisel Verilerin İşlenme Amaçları' : 'Purposes of Processing Personal Data'}
            </h2>
            <p className="text-gray-600 mb-4">
              {language === 'tr'
                ? 'Kişisel verileriniz; müşteri ilişkileri yönetimi, teklif hazırlama, hizmet sunumu, yasal yükümlülüklerin yerine getirilmesi ve ıletişim faaliyetlerinin yürütülmesi amaçlarıyla işlenmektedir.'
                : 'Your personal data is processed for the purposes of customer relationship management, offer preparation, service delivery, fulfilling legal obligations and conducting communication activities.'}
            </p>

            <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">
              {language === 'tr' ? 'Veri Sahibinin Hakları' : 'Rights of the Data Subject'}
            </h2>
            <p className="text-gray-600 mb-4">
              {language === 'tr'
                ? 'KVKK\'nın 11. maddesi uyarınca, kişisel verilerinizin işlenip işlenmediğini öğrenme, işlenmişse bilgi talep etme, işlenme amacını ve amacına uygun kullanılıp kullanılmadığını öğrenme, eksik veya yanlış işlenmiş olması halinde düzeltilmesini isteme, silinmesini veya yok edilmesini isteme haklarına sahipsiniz.'
                : 'In accordance with Article 11 of the KVKK, you have the right to learn whether your personal data is being processed, to request information if it has been processed, to learn the purpose of processing and whether it is used in accordance with its purpose, to request correction if it is incomplete or incorrectly processed, to request deletion or destruction.'}
            </p>

            <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">
              {language === 'tr' ? 'İletişim' : 'Contact'}
            </h2>
            <p className="text-gray-600">
              {language === 'tr'
                ? 'KVKK haklarınızı kullanmak için info@nanogen.com.tr adresine başvurabilirsiniz.'
                : 'To exercise your KVKK rights, you can contact info@nanogen.com.tr.'}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
